// =============================================================================
// GoalCard — the target, without the live headcount
// =============================================================================
// Was `Counter`: it fetched /api/counter and rendered the live national total
// against the 150,000 target plus a progress bar. The running total of people
// who joined is no longer shown anywhere on the public site — only the target
// itself remains. A supporter still sees how many people joined through THEM
// (StatusPage), which is personal, not national.
// =============================================================================

import { formatNumber } from "@/lib/utils"

const TARGET = 150_000

export function GoalCard() {
  return (
    <div className="rounded-2xl border border-[#1B2D52]/15 bg-white shadow-xl shadow-[#1B2D52]/5 p-7">
      <div className="text-xs font-semibold uppercase tracking-wide text-[#6B7280] mb-3">
        היעד שלנו
      </div>
      <div className="flex items-end gap-3 mb-3" dir="ltr">
        <span className="text-5xl lg:text-6xl font-extrabold tracking-tight text-[#1B2D52] leading-none tabular-nums">
          {formatNumber(TARGET)}
        </span>
        <span className="text-2xl font-semibold text-[#6B7280] pb-1">תומכים</span>
      </div>
      <p className="text-sm text-[#4B5563] leading-relaxed">
        זה מה שצריך כדי להיכנס לכנסת. כל הצטרפות — דגל חדש על המפה, וצעד אחד קרוב יותר.
      </p>
    </div>
  )
}
